import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { authApi, setToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    try {
      const me = await authApi.me();
      setUser(me);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    check();
  }, [check]);

  const login = async (email, password) => {
    const u = await authApi.login({ email, password });
    setToken(u.token);
    setUser(u);
    return u;
  };

  const adminLogin = async (email, password) => {
    const u = await authApi.adminLogin({ email, password });
    setToken(u.token);
    setUser(u);
    return u;
  };

  const register = async (email, password, name) => {
    const u = await authApi.register({ email, password, name });
    setToken(u.token);
    setUser(u);
    return u;
  };

  const logout = async () => {
    try {
      await authApi.logout();
    } catch {
      // Lokalni token se svejedno briše.
    }

    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        login,
        adminLogin,
        register,
        logout,
        refresh: check,
        setUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);